<!-- Progress bar -->
<gnx-progress-bar></gnx-progress-bar>

<router-outlet></router-outlet>